import axios from 'axios'

const defaultClient = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 10000
})

defaultClient.defaults.headers.common['x-api-key'] = 'b5pNXeejUi3rXtZYTucOb8IbFj5lYGFX4IHbOLAD'

const clients = {
  default: {
    client: defaultClient
  }
}

export default clients
